// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newText":"B_7u2g"};